import { Component } from '@angular/core';

@Component({
    selector: 'app-registration-end',
    templateUrl: './registration-end.component.html',
    styleUrls: ['./registration-end.component.css'],
    standalone: false
})
export class RegistrationEndComponent {

}
